/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const getSelectedSecurityGroups = (options: string[]) => {
  const securityGroups = options.filter((val) => val.startsWith("sg-"));
  return [...new Set(securityGroups)];
};
